import { render } from "./BlogHopways.vue?vue&type=template&id=02bf747c"
import script from "./BlogHopways.vue?vue&type=script&lang=js"
export * from "./BlogHopways.vue?vue&type=script&lang=js"

import "./BlogHopways.vue?vue&type=style&index=0&id=02bf747c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__